import React, { useState,createContext,ReactNode, SetStateAction,useEffect,useContext } from 'react';
import {IAsaSessionState} from '../types/types'
import {useMainAsaSession} from '../services/AsaSessionServices'
import { useTranslation } from 'react-i18next';
import FailPage from './FailPage';
import { AsaStateContext } from '../components/AsaStateProvider'
const AsaLoadingContext = createContext<[boolean,React.Dispatch<SetStateAction<boolean>>]>([false,(s)=>{}]);
interface Props {
    children?: ReactNode
    // any props that come into the component
  }
const AsaSessionContext = ({ children, ...props }: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const session=useMainAsaSession(setIsLoading)
    const [state, setState] = useContext(AsaStateContext)
    const { i18n } = useTranslation();
    const isError=!!state?.error;

    useEffect(() => {
      if(session.language){
        i18n.changeLanguage(session.language.slice(0, 2));
      }else{
        i18n.changeLanguage("en");
      }
    }, [session.language, i18n]);
    return (
      <AsaLoadingContext.Provider value={[isLoading,setIsLoading]}>
        {isError ? (
          <FailPage/>
        ) : (
          <>{children}</>
        )}
        
      </AsaLoadingContext.Provider>
    );
  };
  export {AsaLoadingContext, AsaSessionContext}